export const COMMENT_LENGTH_LIMITS = {
  RETURN_REASON: 2000,
  SURVEY_REQUEST: 300
};
